/** Bază catalog BMW/MINI BavAUTO (CATCAR). */
export const BAVAUTO_ETK_BASE_URL = "https://etk.bavauto.ro/bmw/";

/**
 * Vehicul din decode-ul nostru — marcă BMW sau VIN WMI BMW (WB… / WBS…).
 * @param {{ brand?: string, vin_full?: string, vin_last7?: string }} vehicle
 */
export function isBmwVinForEtk(vehicle) {
  if (!vehicle) return false;
  if (String(vehicle.brand || "").toUpperCase().includes("BMW")) return true;
  const vf = String(vehicle.vin_full || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  if (vf.length === 17 && (vf.startsWith("WB") || vf.startsWith("WBS") || vf.startsWith("WMW"))) {
    return true;
  }
  return false;
}

/**
 * Link ETK cu VIN în query (ex. `?vin=…`) — dacă serverul CATCAR îl acceptă, câmpul de căutare e preumplut.
 * Preferă VIN complet 17 caractere; altfel ultimele 7 (compatibil flux BMW).
 */
export function buildBavautoEtkUrl(vinFull, vinLast7) {
  const full = String(vinFull || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  const last = String(vinLast7 || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  const vin = full.length === 17 ? full : last.length >= 7 ? last.slice(-7) : "";
  if (!vin) return BAVAUTO_ETK_BASE_URL;
  try {
    const u = new URL(BAVAUTO_ETK_BASE_URL);
    u.searchParams.set("vin", vin);
    return u.toString();
  } catch {
    return `${BAVAUTO_ETK_BASE_URL}?vin=${encodeURIComponent(vin)}`;
  }
}
